import { Injectable } from '@angular/core';

export type GetmIconVariant = 'filled' | 'outline';
export type GetmIconSize = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | 'xxxl';

// Lista de iconos disponibles del design system GETM
export const GETM_ICONS = [
  'alarm',
  'alert-triangle',
  'arrow-down',
  'box',
  'box-fav',
  'calendar',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'close',
  'cup',
  'delivery',
  'delivery-time',
  'document',
  'email',
  'enfriadores',
  'home',
  'information-circle',
  'lock',
  'menu-3',
  'menus-circle',
  'minus-circle',
  'plus-ellipse',
  'search',
  'star',
  'trash',
] as const;

export type GetmIconName = typeof GETM_ICONS[number];

// Mapeo de tamaños a píxeles (sincronizado con GETM Design System)
export const GETM_SIZE_MAP: Record<GetmIconSize, number> = {
  xxs: 12,
  xs: 16,
  s: 20,
  m: 24,
  l: 32,
  xl: 36,
  xxl: 40,
  xxxl: 48
};

@Injectable({
  providedIn: 'root'
})
export class GetmIconService {

  private readonly basePath = 'assets/figma/icons';

  /**
   * Obtiene la ruta completa del icono SVG
   * @param name Nombre del icono
   * @param variant Variante: 'filled' o 'outline'
   * @returns Ruta del archivo SVG
   */
  public getIconPath(name: string, variant: GetmIconVariant = 'outline'): string {
    if (!name) return '';
    return `${this.basePath}/${variant}/${name}.svg`;
  }

  /**
   * Obtiene el tamaño en píxeles para un tamaño predefinido
   * @param size Tamaño predefinido
   * @returns Tamaño en píxeles
   */
  public getSizeInPixels(size: GetmIconSize): number {
    return GETM_SIZE_MAP[size] || GETM_SIZE_MAP.m;
  }

  /**
   * Obtiene el tamaño como string CSS
   * @param size Tamaño predefinido
   * @returns Tamaño con unidad px
   */
  public getSizeString(size: GetmIconSize): string {
    return `${this.getSizeInPixels(size)}px`;
  }


}
